import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TFlaggedConnectionsDetails } from "../../Types";

export const apiCallFushHosts = async ({
  email,
  password,
  passCode
}: {
  email: string;
  password: string;
  passCode: string;
}) => {
  const { status, data, et3Error } = await post<{
    data: TFlaggedConnectionsDetails;
  }>(`developer/flush`, {
    email,
    password,
    passCode
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
